import React from 'react';

const s = {
  bar: 'flex items-center w-full px-4 py-1 bg-[rgba(235,246,242,0.35)] border-b border-[#e1e5e9]',
  statsRow: 'flex items-center gap-3 text-sm',
  statGroup: 'flex items-center gap-2',
  statLabel: 'font-semibold text-foreground',
  divider: 'text-[#c0c8d0] select-none',
} as const;

interface ExportSummaryControlBarProps {
  /** Rows in the tab currently being viewed. */
  rowCount: number;
  /** Distinct sequences across every export tab — what Finalize export will produce. */
  selectedCount: number;
}

/**
 * ExportSummaryControlBar — the Hit selection control bar reduced to what Export summary
 * can act on: the stats line.
 *
 */
export function ExportSummaryControlBar({ rowCount, selectedCount }: ExportSummaryControlBarProps) {
  return (
    <div className={s.bar}>
      <div className={s.statsRow}>
        <div className={s.statGroup}>
          <span className={s.statLabel}>{rowCount} sequences</span>
          <span className={s.divider}>|</span>
          <span className={s.statLabel}>{selectedCount} selected for export</span>
        </div>
      </div>
    </div>
  );
}
